import { createValidations, Validation, ValidationHandler } from './validator';

export type RequiredValidation<T> = (message: string, id?: string) => Validation<T>;

export const createRequired =
  <T>(chain: ValidationHandler<T>[]) =>
  (message: string, id?: string) =>
    createValidations<T>([
      ...chain,
      async (value) => {
        if (typeof value === 'string') {
          return [{ valid: (value as string).trim().length > 0, message, id }];
        }

        return [{ valid: value !== undefined && value !== null, message, id }];
      }
    ]);
